import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledTag = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 26px;
  margin-left: ${p => p.theme.spacing(2)};
  padding: 0 ${p => p.theme.spacing(2)};
  color: ${p => p.theme.colours.white};
  background: linear-gradient(
    90deg,
    ${p => p.theme.colours.cisPrimary} 0%,
    ${p => p.theme.colours.cisSecondary} 100%
  );
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    right: 100%;
    width: 20px;
    height: 20px;
    background: ${p => p.theme.colours.cisPrimary};
    border-radius: 4px;
    transform: translateX(50%) translateY(-50%) rotate(-45deg);
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    width: 4px;
    height: 4px;
    background-color: ${p => p.theme.colours.white};
    border-radius: 100%;
  }
`;

const LabelTag = props => {
  const { children } = props;

  return <StyledTag>{children}</StyledTag>;
};

LabelTag.propTypes = {
  children: PropTypes.node
};

export default LabelTag;
